<template>
	<PageLoading :is-loading="isLoading"></PageLoading>
	<SideComponent @scrollto="scroll"></SideComponent>
	<div class="container" ref="viewBox">
		<Header2 :show-search-bar-pic="showHeader" login-style="loginStyle" :mobile-icon-style="mobileIconStyle" :show-list-icon="showListIcon"/>
		<div class="content">
			<div style="height:60px;" class="other"></div>
			<div class="detail-container">
				<div class="outer">
					<div class="cats">
						<button
							v-if="showBackButton"
							type="button"
							class="video-detail-back"
							@click="goBackToSource"
						>
							‹ {{ $t('newIndex.sections.visual.backToSection') }}
						</button>
					</div>
					<div class="a1">
						<div class="detail-left">
							<div class="img-outer">
								<div ref="videoContainer" v-if="isMobile" class="video-container">
								    <!-- <video v-if="videoDetail.direction!=3" ref="videoPlayer" class="video-js vjs-default-skin" style="width:auto;height:600px;"></video> -->
								    <video ref="videoPlayer" class="video-js vjs-default-skin" style="width:100%;height:auto;"></video>
								</div>
								<!-- <videoPlay v-if="isMobile"
								    :title="videoDetail.title"
								    :src="sources.src"
								    :poster="videoOptions.poster"
								    style="width:100%;height:100%;"
								/> -->
								<!-- <VideoPlayer  :options="videoOptions" class="video-css"/> -->
								<!-- <video v-if="isMobile && videoDetail.direction!=3"								
								    :poster="videoDetail.thumb" 
								    controls
								    preload="metadata"
								    muted 
								    :alt="videoDetail.title" 
								    style="object-fit:cover;width:100%;height:100%;border-radius: 8px;" 
								    controlslist="nodownload" 
								    oncontextmenu="return false"
								    x5-playsinline playsinline webkit-playsinline
								    >								
									<source :src="videoDetail.url" type="video/mp4">
								</video> -->
								<video v-if="!isMobile && videoDetail.direction!=3"
								    controls								
								    :poster="videoDetail.thumb" 
								    preload="none" 
								    muted 
								    :alt="videoDetail.title" 
								    style="object-fit:cover;width:100%;height:100%;border-radius: 8px;" 
								    controlslist="nodownload" 
								    oncontextmenu="return false"
								    :src="videoDetail.url"
								    
								    >
								    <!-- @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave" -->
									<track kind="captions" />
									<!-- <source :src="item.url" type="video/mp4"> -->
								</video>
								<video v-if="!isMobile && videoDetail.direction==3"
								    controls								
								    :poster="videoDetail.thumb" 
								    preload="none" 
								    muted 
								    :alt="videoDetail.title" 
								    style="object-fit:contain;width:auto;max-height:600px;border-radius: 8px;" 
								    controlslist="nodownload" 
								    oncontextmenu="return false"
								    :src="videoDetail.url"
								    
								    >
								    <!-- @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave" -->
									<track kind="captions" />
									<!-- <source :src="item.url" type="video/mp4"> -->
								</video>
							</div>

							
							
						</div>
						<div class="detail-right">
							
							<div class="b4">
								<div class="pic-detail">
									<div class="detail-item">
										<span class="title">{{$t('video.text1')}}</span><span class="item-content">{{videoDetail.id}}</span>
									</div>
									<div class="detail-item" v-if="videoDetail.id">
										<span class="title">{{$t('contentViews')}}:</span><span class="item-content">{{views}}</span>
									</div>
									<div class="detail-item" v-if="videoDetail.title">
										<span class="title">{{$t('video.text2')}}</span><span class="item-content">{{videoDetail.title}}</span>
									</div>
									<div class="detail-item" v-if="videoDetail.extension">
										<span class="title">{{$t('video.text3')}}</span><span class="item-content">{{videoDetail.extension}}</span>
									</div>
									<div class="detail-item" v-if="videoDetail.duration">
										<span class="title">{{$t('video.text4')}}</span><span class="item-content">{{videoDetail.duration}}</span>
									</div>
									<div class="detail-item" v-if="videoDetail.size">
										<span class="title">{{$t('video.text5')}}</span><span class="item-content">{{videoDetail.size}}MB</span>
									</div>
									<div class="detail-item" v-if="videoDetail.description">
										<span class="title">{{$t('video.desc')}}</span><span class="item-content">{{videoDetail.description}}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				
			</div>
			<div class="middle-content">
				<div class="middle-wrapper">
					<!-- <div class="middle-first">
						<span class="ftip">此素材包含的地点信息:</span>
						<span class="fposition">中国</span>
						<span class="fposition">山东省</span>
						<span class="fposition">青岛</span>
					</div> -->
					<div class="middle-second">
						<div class="mkeywords">
							<span class="kw">{{$t('video.tip1')}}</span>
						</div>
						<div class="mtag">
							<span class="mt" v-for="item in videoDetail.keywords">{{item}}</span>
							
						</div>
					</div>
				</div>
			</div>
			<div class="pic-title">
				<span class="span">{{$t('video.tip2')}}</span>
			</div>
			<div class="enclosure" style="">
				<section class="section">
					<div class="_1Aw4E" :style="activeStyle(item)" v-for="item in videos" @click="changeVideoinfo(item.id)">   <!--  -->
						<div style="width:100%;height:100%;">
							<video v-if="isMobile"								
							    :poster="item.thumb" 
							    controls
							    preload="none"
							    muted 
							    :alt="item.title" 
							    style="object-fit:cover;width:100%;height:100%;border-radius: 8px;" 
							    controlslist="nodownload" 
							    oncontextmenu="return false"
							    x5-playsinline playsinline webkit-playsinline
							    >								
								<source :src="item.url" type="video/mp4">
							</video>
							<video v-if="!isMobile"
							    controls								
							    :poster="item.thumb" 
							    preload="none" 
							    muted 
							    :alt="item.title" 
							    style="object-fit:cover;width:100%;height:100%;border-radius: 8px;" 
							    controlslist="nodownload" 
							    oncontextmenu="return false"
							    :src="item.url"
							    
							    >
							    <!-- @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave" -->
								<track kind="captions" />
								<!-- <source :src="item.url" type="video/mp4"> -->
							</video>
							<!-- <video 
							      controls 
							      :poster="item.thumb" 
							      preload="none" 
							      muted="" 
							      :alt="item.title" 
							      style="object-fit:cover;width:100%;height:100%;" 
							      controlslist="nodownload"
							      oncontextmenu="return false"
							      @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
								<source :src="item.url" type="video/mp4">
							</video> -->
						</div>
						<div class="video_name">{{item.title}}</div>
					</div>
					
				</section>
				<div class="loadmore">
					<Loading :is-loading="isVideoLoading"></Loading>
					<span class="more" @click="loadMore()" v-if="!nomore">{{$t('loadmore')}}</span>
					<span class="end" v-if="nomore">- {{$t('theEnd')}} -</span>
				</div>
			</div>

		</div>
		<Footer/>
	</div>
</template>

<script>
	import video_detail from './topic_video_detail_controller';
	export default video_detail;
</script>

<style src="@/assets/css/topic_video_detail.css" scoped> </style>